import classNames from 'classnames';
import React, { useCallback } from 'react';

import { useSystem } from '@core';
import { WindowLevelMenuItem } from '@ui';
import { ListCustomPreset } from './ListCustomPreset';

export interface CustomPresetsProps {
	modality?: string;
}

/**
 * Nút User Define Preset + Danh sách Preset đã tạo
 */
export const CustomPresets = ({ modality }: CustomPresetsProps) => {
	console.log('CustomPresets rendered for modality:', modality);

	const { commandsManager } = useSystem();
	const onClick = useCallback(() => {
		commandsManager.runCommand('openPopupDefinePreset');
	}, [commandsManager]);

	return (
		<>
			<div className={classNames('cursor-pointer bg-primary-main text-common-bright')} onClick={onClick}>
				<WindowLevelMenuItem title="User Define" />
			</div>
			<ListCustomPreset />
		</>
	);
};
